interface FeaturedItem {
    imgUrl: string;
    alt: string;
}

export const featuredItems: FeaturedItem[] = [
    {
        imgUrl: 'marketing_site/featured_in/fortune-dark.png',
        alt: 'Fortune'
    },
    {
        imgUrl: 'marketing_site/featured_in/cnbc-dark.png',
        alt: 'CNBC'
    },
    {
        imgUrl: 'marketing_site/featured_in/fast-company-dark.png',
        alt: 'Fast Company'
    },
    {
        imgUrl: 'marketing_site/featured_in/forbes-dark.png',
        alt: 'Forbes'
    },
    {
        imgUrl: 'marketing_site/featured_in/reuters-dark.png',
        alt: 'Reuters'
    },
    {
        imgUrl: 'marketing_site/featured_in/tc-dark.png',
        alt: 'Tech Crunch'
    }
];
